
// Preferenza di sistema "riduci movimento": letta una volta, usata da tutti gli effetti.
var EVEA_REDUCE = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

// ─── Hero height lock ───
// Setta --hero-vh = window.innerHeight al primo paint.
// IMPORTANTE: su mobile NON ascoltare resize: il toggle URL bar di iOS Safari
// (visibile/nascosta durante scroll) scatena resize → ricalcola altezza hero →
// video object-fit ricomputa crop → percepito come ZOOM del video durante scroll.
// Su desktop il resize è una vera azione utente quindi lo gestiamo.
(function(){
  function lockHeroHeight(){
    document.documentElement.style.setProperty('--hero-vh', window.innerHeight + 'px');
  }
  lockHeroHeight();
  var isMobile = window.matchMedia('(max-width: 989px)').matches;
  if (!isMobile) {
    window.addEventListener('resize', lockHeroHeight);
  }
  // Orientation change (mobile): aggiorniamo solo qui, è un vero cambio viewport
  window.addEventListener('orientationchange', function(){ setTimeout(lockHeroHeight, 100); });
})();

// ─── Hero video mobile autoplay fix ───
(function(){
  var v = document.getElementById('hero-video');
  if(!v) return;
  function tryPlay(){
    var p = v.play();
    if(p !== undefined) p.catch(function(){});
  }
  tryPlay();
  document.addEventListener('touchstart', function once(){
    tryPlay();
    document.removeEventListener('touchstart', once);
  }, {passive:true});
  document.addEventListener('scroll', function once(){
    tryPlay();
    document.removeEventListener('scroll', once);
  }, {passive:true});
})();

// ─── Video "lazy": partono solo quando entrano nello schermo ───
// Prima il video community (31 MB .mov) partiva in autoplay al caricamento
// della home. Ora è un MP4 da 2 MB con poster e si avvia solo quando è visibile.
(function(){
  var vids = document.querySelectorAll('video[data-lazy-video]');
  if (!vids.length || !('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      var v = e.target;
      if (e.isIntersecting) {
        if (!v.dataset.loaded) { v.preload = 'auto'; v.dataset.loaded = '1'; }
        var p = v.play(); if (p && p.catch) p.catch(function(){});
      } else if (!v.paused) { v.pause(); }
    });
  }, { threshold: .25 });
  vids.forEach(function(v){ io.observe(v); });
})();

// ─── Instagram "lazy": l'iframe si carica solo vicino allo schermo ───
// Sotto ogni iframe c'è un segnaposto EVEA (.ig-ph) che linka al Reel: se
// l'embed è bloccato o non carica, si vede quello e mai un riquadro nero.
// L'iframe compare in dissolvenza solo quando ha finito di caricare.
(function(){
  var frames = document.querySelectorAll('iframe[data-ig-src]');
  if (!frames.length) return;
  function load(f){
    if (f.dataset.igLoaded) return;
    f.dataset.igLoaded = '1';
    var tile = f.closest('.ig');
    f.addEventListener('load', function(){ if (tile) tile.classList.add('ig-ready'); }, { once: true });
    f.src = f.getAttribute('data-ig-src');
  }
  if (!('IntersectionObserver' in window)) { frames.forEach(load); return; }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if (!e.isIntersecting) return;
      load(e.target);
      io.unobserve(e.target);
    });
  }, { rootMargin: '300px 0px' });
  frames.forEach(function(f){ io.observe(f); });
})();

// ─── Animazioni infinite in pausa quando la sezione è fuori schermo ───
// (ticker hero, vapore, puntino "live", nastro trust, freccia tabella)
(function(){
  var els = document.querySelectorAll('.hero, .trust-strip, .comp-tbl-wrap');
  if (!els.length || !('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ e.target.classList.toggle('is-offscreen', !e.isIntersecting); });
  });
  els.forEach(function(el){ io.observe(el); });
})();

// ─── Progress bar + Nav + Hero parallax ───
// IMPORTANTE: scroll handler throttled via rAF per evitare update continui che
// causano layout invalidation visibile come "jitter" dell'header durante scroll.
var heroBg = document.querySelector('.hero-bg video') || document.querySelector('.hero-bg img');
var _rafScroll = null;
var _lastScrollY = 0;
function _onScrollFrame(){
  _rafScroll = null;
  var y = _lastScrollY;
  var prog = document.getElementById('evea-prog');
  if (prog) prog.style.width = (y/(document.documentElement.scrollHeight-innerHeight)*100)+'%';
  var shopHdr = document.querySelector('.shopify-section-group-header-group header');
  if (shopHdr) shopHdr.classList.toggle('evea-scrolled', y > 60);
  // Parallax SOLO desktop (>989px). Su mobile l'effetto combinato con il
  // toggle dell'address bar produce un "zoom percepito" fastidioso.
  // Rispetta anche prefers-reduced-motion per accessibilità.
  if(heroBg && y < innerHeight*1.2 && window.innerWidth > 989 && !EVEA_REDUCE){
    heroBg.style.transform = 'scale(1.08) translateY('+(y*.13)+'px)';
  }
}
document.addEventListener('scroll', function(){
  _lastScrollY = window.scrollY;
  if (_rafScroll === null) _rafScroll = requestAnimationFrame(_onScrollFrame);
},{passive:true});

// ─── Scroll reveal ───
// Gestito dal sistema globale assets/evea-motion.js (data-evea-reveal /
// data-evea-lines / data-evea-mask). Il vecchio .rv è stato migrato.

// ─── Accordion (with ARIA support) ───
document.querySelectorAll('.acc-head').forEach(function(h){
  h.addEventListener('click',function(){
    var item = h.parentElement;
    var wasOpen = item.classList.contains('open');
    document.querySelectorAll('.acc-item').forEach(function(i){
      i.classList.remove('open');
      var btn = i.querySelector('.acc-head');
      if(btn) btn.setAttribute('aria-expanded','false');
    });
    if(!wasOpen){
      item.classList.add('open');
      h.setAttribute('aria-expanded','true');
    }
  });
});

// ─── Animated counters ───
document.querySelectorAll('.gano').forEach(function(sec){
  if (!('IntersectionObserver' in window)) return;
  new IntersectionObserver(function(e){
    if(e[0].isIntersecting){
      sec.querySelectorAll('.cn').forEach(function(el){
        var t = parseInt(el.dataset.target);
        if(!t||el.dataset.done) return;
        el.dataset.done = '1';
        if (EVEA_REDUCE) { el.textContent = t; el.classList.add('cn-done'); return; }
        var dur=1800, st=performance.now();
        (function step(now){
          var p = Math.min((now-st)/dur,1);
          p = 1-Math.pow(1-p,3);
          el.textContent = Math.round(t*p);
          if(p<1){ requestAnimationFrame(step); }
          else { el.classList.add('cn-done'); }
        })(st);
      });
    }
  },{threshold:.25}).observe(sec);
});

// ─── Vapore leggero nell'hero: solo desktop e senza "riduci movimento" ───
(function(){
  if (EVEA_REDUCE || window.innerWidth < 990) return;
  var hero = document.querySelector('.hero');
  if(!hero) return;
  var wrap = document.createElement('div');
  wrap.className = 'steam-wrap';
  wrap.setAttribute('aria-hidden', 'true');
  var cfg = [
    {l:0,  d:4.3, dl:0,   dx:7,  dx2:-3, w:4},
    {l:14, d:5.7, dl:0.9, dx:-6, dx2:9,  w:3},
    {l:7,  d:4.0, dl:1.8, dx:9,  dx2:2,  w:5},
    {l:22, d:6.3, dl:0.5, dx:-5, dx2:-6, w:3},
    {l:-4, d:5.0, dl:2.4, dx:6,  dx2:-3, w:4},
  ];
  cfg.forEach(function(c){
    var p = document.createElement('div');
    p.className = 'stp';
    p.style.cssText = 'left:'+c.l+'px;--d:'+c.d+'s;--dl:'+c.dl+'s;--dx:'+c.dx+'px;--dx2:'+c.dx2+'px;--w:'+c.w+'px;width:'+c.w+'px;height:'+c.w+'px';
    wrap.appendChild(p);
  });
  hero.insertBefore(wrap, hero.querySelector('.hero-content'));
})();

// ─── Timeline line draw ───
var tl = document.querySelector('.timeline');
if(tl && 'IntersectionObserver' in window){
  new IntersectionObserver(function(e){
    if(e[0].isIntersecting) tl.classList.add('tl-vis');
  },{threshold:.2}).observe(tl);
}

// ─── Gold shimmer on comp-stat numbers ───
document.querySelectorAll('.comp-row').forEach(function(row){
  if (EVEA_REDUCE || !('IntersectionObserver' in window)) return;
  var done = false;
  new IntersectionObserver(function(e){
    if(e[0].isIntersecting && !done){
      done = true;
      row.querySelectorAll('.comp-stat').forEach(function(s,i){
        setTimeout(function(){ s.classList.add('cs-shim'); }, i*150);
      });
    }
  },{threshold:.3}).observe(row);
});

// (Rimossi 26/09/2026 — ondata 3: tilt 3D sulle card prodotto, ripple sui CTA,
//  micro-particelle dorate, pulsanti "magnetici" e scia dorata del cursore.
//  Effetti datati e costosi: il look ora è affidato a transizioni CSS calme.)

// ─── Reviews carousel con frecce ───
(function(){
  var scroll = document.querySelector('.social-scroll');
  var prevBtn = document.getElementById('reviews-prev');
  var nextBtn = document.getElementById('reviews-next');
  if(!scroll || !prevBtn || !nextBtn) return;

  function getCardW(){
    var card = scroll.querySelector('.sp-card');
    return card ? card.offsetWidth + 16 : 336;
  }

  nextBtn.addEventListener('click', function(){
    scroll.scrollBy({ left: getCardW() * 2, behavior: 'smooth' });
  });
  prevBtn.addEventListener('click', function(){
    scroll.scrollBy({ left: -getCardW() * 2, behavior: 'smooth' });
  });

  // Aggiorna visibilità frecce
  function updateButtons(){
    prevBtn.style.opacity = scroll.scrollLeft < 10 ? '0.35' : '1';
    nextBtn.style.opacity = (scroll.scrollLeft + scroll.clientWidth >= scroll.scrollWidth - 10) ? '0.35' : '1';
  }
  scroll.addEventListener('scroll', updateButtons, { passive: true });
  updateButtons();
})();

// (Rimossi 26/09/2026: vecchio megamenu iniettato via JS e vecchio selettore bandiera.
 //  I selettori non corrispondevano più all'header Horizon: non si vedevano mai, ma
 //  scaricavano un PNG da 1,1 MB e ricalcolavano la posizione a ogni scroll.
 //  Il megamenu vero è sections/evea-megamenu.liquid.)

// ─── Bottoni "Acquista" nelle card prodotto ───
// Ogni .pc-bt apre il drawer con il prodotto corrispondente
(function() {
  function attachPcBtHandlers() {
    document.querySelectorAll('.pc-bt').forEach(function(btn) {
      if (btn.dataset.eveaAttached) return;
      btn.dataset.eveaAttached = '1';

      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        // Trova il link al prodotto nella card
        var card = btn.closest('.pc, .pc-rev, [class*="pc "]');
        if (!card) return;

        // FIX i18n (24/09/2026): la card STESSA è un <a> (wrapper), non contiene
        // altri <a> figli. querySelector('a[href*="/products/"]') restituiva null
        // e il codice cadeva sul fallback '/products/'+handle SENZA prefisso lingua,
        // portando gli utenti rumeni sulla versione italiana della pagina prodotto.
        var link = (card.tagName === 'A' && (card.getAttribute('href') || '').indexOf('/products/') !== -1)
          ? card
          : card.querySelector('a[href*="/products/"]');
        var href = link ? link.getAttribute('href') : null;
        var handle = href ? href.replace(/.*\/products\//, '').split('?')[0] : null;
        if (!handle) {
          var nameEl = card.querySelector('.pc-n');
          if (nameEl) handle = nameEl.textContent.trim().toLowerCase().replace(/\s+/g, '-');
        }
        if (!handle) return;

        // Pre-launch block: se il modal waitlist e' ancora renderizzato
        // (vedi theme.liquid: evea_prelaunch_end_ts) mostralo per i 4 caffe'
        // singoli. Passata la scadenza, il modal non esiste piu'.
        var PRELAUNCH_BLOCKED = ['black', 'mocha', 'latte', 'green-tea'];
        if (PRELAUNCH_BLOCKED.indexOf(handle) !== -1 && typeof window.eveaShowPrelaunchModal === 'function') {
          window.eveaShowPrelaunchModal(handle);
          return;
        }

        // Naviga alla pagina prodotto — se il fallback si attiva, prefissa la lingua
        // corrente (letta da <html lang>) così l'utente rumeno non finisce in italiano.
        var _lang = (document.documentElement.lang || '').substring(0, 2);
        var _prefix = (_lang && _lang !== 'it') ? '/' + _lang : '';
        window.location.href = href || (_prefix + '/products/' + handle);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachPcBtHandlers);
  } else {
    attachPcBtHandlers();
  }
  // Retry per card aggiunte più tardi (theme editor)
  setTimeout(attachPcBtHandlers, 1000);
})();

// ════════════════════════════════════════
//   EFFETTI "FIRMA" RIPRISTINATI (richiesta cliente 26/09/2026)
//   Pulsanti magnetici, stelline dorate che seguono il mouse, ripple.
//   Solo desktop con mouse, mai con "riduci movimento".
// ════════════════════════════════════════
(function(){
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!fine || reduce || window.innerWidth < 960) return;

  // ─── Pulsanti magnetici: il pulsante "viene incontro" al mouse ───
  document.querySelectorAll('.btn-hero-primary,.btn-hero-secondary,.btn-p,.pc-bt').forEach(function(btn){
    btn.classList.add('btn-magnetic');
    var raf = null;
    btn.addEventListener('mousemove', function(e){
      var r = btn.getBoundingClientRect();
      var x = e.clientX - r.left - r.width / 2;
      var y = e.clientY - r.top - r.height / 2;
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function(){
        btn.style.transform = 'translate(' + (x * 0.25) + 'px,' + (y * 0.25) + 'px)';
      });
    });
    btn.addEventListener('mouseleave', function(){
      if (raf) cancelAnimationFrame(raf);
      btn.style.transform = '';
    });
  });

  // ─── Ripple al click sui pulsanti principali ───
  document.querySelectorAll('.btn-p').forEach(function(btn){
    btn.addEventListener('click', function(e){
      var r = document.createElement('span');
      r.className = 'ripple-el';
      var sz = Math.max(btn.clientWidth, btn.clientHeight);
      var rect = btn.getBoundingClientRect();
      r.style.cssText = 'width:' + sz + 'px;height:' + sz + 'px;left:' + (e.clientX - rect.left - sz / 2) + 'px;top:' + (e.clientY - rect.top - sz / 2) + 'px';
      btn.appendChild(r);
      setTimeout(function(){ r.remove(); }, 750);
    });
  });

  // ─── Stelline dorate che seguono il mouse nelle sezioni scure ───
  var canvas = document.getElementById('evea-cursor-trail');
  if (!canvas) return;
  var ctx = canvas.getContext('2d');
  var particles = [];
  var raf = null;
  function resize(){ canvas.width = window.innerWidth; canvas.height = window.innerHeight; }
  resize();
  window.addEventListener('resize', resize);

  function animate(){
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    for (var i = particles.length - 1; i >= 0; i--) {
      var p = particles[i];
      p.x += p.vx; p.y += p.vy; p.life -= 0.02;
      if (p.life <= 0) { particles.splice(i, 1); continue; }
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(196,163,90,' + (p.life * 0.7) + ')';
      ctx.fill();
    }
    // si ferma da solo quando non ci sono più stelline (niente lavoro a vuoto)
    raf = particles.length ? requestAnimationFrame(animate) : null;
  }

  var lastCheck = 0, overDark = false;
  document.addEventListener('mousemove', function(e){
    // controlla la sezione sotto il mouse al massimo ogni 80 ms (più leggero)
    var now = e.timeStamp || Date.now();
    if (now - lastCheck > 80) {
      lastCheck = now;
      var el = document.elementFromPoint(e.clientX, e.clientY);
      overDark = !!(el && el.closest('.hero, .gano, .final'));
    }
    if (!overDark) return;
    for (var i = 0; i < 2; i++) {
      particles.push({
        x: e.clientX + (Math.random() - 0.5) * 8,
        y: e.clientY + (Math.random() - 0.5) * 8,
        size: Math.random() * 3 + 1,
        vx: (Math.random() - 0.5) * 1.5,
        vy: (Math.random() - 0.5) * 1.5 - 1,
        life: 1
      });
    }
    if (!raf) raf = requestAnimationFrame(animate);
  }, { passive: true });
})();
